import React, { useEffect, useRef } from 'react';
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
import { useField } from 'formik';
import { FormControl, InputLabel, FormHelperText } from '@mui/material';
import './phone-input.scss';
import { borderColor } from 'polished';

function PhoneInputField({ setCountryCode, ...props }) {
    // console.log("props", props);
    const [field, meta, helpers] = useField(props.field.name);

    const handlePhoneChange = (isValid, value, countryData, fullNumber) => {
        // console.log("valid: ", isValid);
        // console.log("value: ", value);
        // console.log("countryData.dialCode: ", countryData.dialCode);
        helpers.setValue(value);
        setCountryCode(countryData.dialCode);
    };

    const handleSelectFlag = (event) => {
        helpers.setValue('');
    };

    return (
        <FormControl error={meta.touched && Boolean(meta.error)} sx={{ width: "100%" }}>
            {/* <InputLabel htmlFor={props.name}>{label}</InputLabel> */}
            <IntlTelInput
                inputClassName="mui-input my-phone-input"
                {...field}
                {...props}
                onPhoneNumberChange={handlePhoneChange}
                onSelectFlag={handleSelectFlag}
            />
            {meta.touched && meta.error && (
                <FormHelperText>{meta.error}</FormHelperText>
            )}
        </FormControl>
    );
}

export default PhoneInputField;
